import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  RowWrapper,
  Section,
  SectionTitle,
  UserFormProps,
} from '../../../components/AdminFormComponents';
import { useTranslation } from 'react-i18next';

export const AIUserFeaturesSection = (props: UserFormProps) => {
  const { t } = useTranslation();
  const {
    values,
    setFieldValue,
    isSubmitting,
    isAISpotlightEnabledForCustomer,
    isAIAssistantEnabledForCustomer,
  } = props;
  return (
    <Section id='aiUserFeaturesSection'>
      <SectionTitle>{t('AI')}</SectionTitle>
      <RowWrapper>
        {/* AI SPOTLIGHT (Flex Video) */}
        {isAISpotlightEnabledForCustomer && (
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='spotlightEnabled'
            label={t('AI Flex Video')}
            info={t(
              'Controls whether a user can create AI Flex videos. Admins can still configure Flex-related assets (avatars, backgrounds, etc.) even if this toggle is off, but they cannot create Flex videos themselves. AI Flex video is toggled on for company admins when toggled on at the customer level.'
            )}
            onChange={() => {
              setFieldValue('spotlightEnabled', !values.spotlightEnabled);
            }}
            disabled={isSubmitting}
          />
        )}
        {/* AI ASSISTANTS */}
        {isAIAssistantEnabledForCustomer && (
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='quickVideoAvatarEnabled'
            label={t('AI Video Agents')}
            info={t(
              'Controls whether a user can see and use quick videos that include AI Video Agent parts. If an admin creates a quick video with an AI Video Agent part, only users with this toggle enabled can see the quick video; users with the toggle disabled would not. AI Video Agents is toggled on for all users when toggled on on customer level.'
            )}
            onChange={() => {
              setFieldValue(
                'quickVideoAvatarEnabled',
                !values.quickVideoAvatarEnabled
              );
            }}
            disabled={isSubmitting}
          />
        )}
      </RowWrapper>
    </Section>
  );
};
